import { render, staticRenderFns } from "./WorkingHours.vue?vue&type=template&id=be80d8a2&scoped=true&"
import script from "./WorkingHours.vue?vue&type=script&lang=js&"
export * from "./WorkingHours.vue?vue&type=script&lang=js&"
import style0 from "./WorkingHours.vue?vue&type=style&index=0&id=be80d8a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be80d8a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VDialog,VIcon,VList,VListItem,VMenu,VSnackbar})
